import React from 'react'

function CheckCircleIcon({ color = "currentColor", size = 26, ...rest }) {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4143_6110)">
                <path d="M10.9005 4.99999C11.1289 6.12064 10.9662 7.28571 10.4395 8.30089C9.91279 9.31608 9.054 10.12 8.00631 10.5787C6.95862 11.0373 5.78536 11.1229 4.6822 10.8212C3.57904 10.5195 2.61265 9.84869 1.94419 8.92071C1.27573 7.99272 0.945611 6.86361 1.00888 5.72169C1.07215 4.57976 1.52499 3.49404 2.29188 2.64558C3.05876 1.79712 4.09334 1.23721 5.22308 1.05922C6.35282 0.881233 7.50944 1.09592 8.50005 1.66749" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
                <path d="M4.5 5.5L6 7L11 2" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_4143_6110">
                    <rect width={size} height={size} fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default CheckCircleIcon